"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRules = void 0;
const validators_1 = require("@vuelidate/validators");
exports.loginRules = {
    username: { required: validators_1.required },
    password: { required: validators_1.required }
};
//# sourceMappingURL=login-validation-rules.js.map